/**
 * @module ClientConfigurationCache
 */

/**
 * @enum
 * The enum for status of the Client configuration cache
 * @property {number} Empty - An empty cache
 * @property {number} Success - A Success response for the service request
 * @property {number} Error - An Error response for the service request
 */

export enum ClientConfigurationCacheState {
    Empty,
    Success,
    Error,
}

/**
 * @interface
 * An interface for the client configuration cache
 * @property {ClientConfigurationCacheState} state - The state of the cached data
 * @property {any} data - The actual configuration data
 * @property {number} time - The timestamp denoting when the service request response is received
 */

export default interface ClientConfigurationCache {
    state: ClientConfigurationCacheState;
    data: any; // config data in case of success, and error object in case of error
    time: number; // Timestamp at which the response received
}
